import { __assign } from "tslib";
import { ChatSdkError, Message } from '@wix/chat-sdk';
import { Chatroom } from '@wix/chat-sdk/lib/src/domain/chat-room';
// TODO add fromSerialize factory to Chatroom
export function deserializeRoom(transferDto) {
    return new Chatroom(__assign(__assign({}, transferDto.room), { lastMessage: transferDto.lastMessage }), transferDto.online);
}
// TODO add serialize method to Chatroom
export function serializeRoom(room) {
    return {
        room: room['_chatroom'],
        lastMessage: room['_lastMessage']._dto,
        online: room.online,
    };
}
// TODO add serialize method to Message
export function serializeMessage(message) {
    return {
        message: message['_dto'],
        transit: serializeTransit(message['_transit']),
    };
}
export function serializeTransit(transit) {
    return __assign(__assign({}, transit), { sendError: serializeError(transit.sendError) });
}
export function serializeError(err) {
    if (!err) {
        return err;
    }
    return {
        message: err.message,
        name: err.name,
        stack: err.stack,
    };
}
// TODO add serialize method to Message
export function deserializeMessage(message) {
    if (message.dto) {
        return message;
    }
    if (message.id) {
        return new Message(message);
    }
    return new Message(message.message, message.transit);
}
export function deserializeTransit(transit) {
    var _a, _b, _c;
    if (!transit) {
        return {};
    }
    var err;
    if (transit.sendError) {
        err = new Error((_a = transit.sendError) === null || _a === void 0 ? void 0 : _a.name);
        err.message = (_b = transit.sendError) === null || _b === void 0 ? void 0 : _b.message;
        err.stack = (_c = transit.sendError) === null || _c === void 0 ? void 0 : _c.stack;
    }
    return {
        file: transit.file,
        isPending: transit.isPending,
        sendStatus: transit.sendStatus,
        status: transit.status,
        sendError: err && new ChatSdkError(err, 'http-error'),
    };
}
//# sourceMappingURL=serializer.js.map